"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import CategoryGrid from "@components/elements/category/CategoryGrid";
import React from "react";

const swiperOptions = {
  modules: [Pagination, Navigation],
  slidesPerView: 6,
  spaceBetween: 30,
  autoplay: {
    delay: 1000,
    disableOnInteraction: false,
  },
  loop: false,
  pagination: {
    dynamicBullets: true,
    el: ".category1-pagination",
    clickable: true,
  },

  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 30,
    },
    575: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    767: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
    991: {
      slidesPerView: 5,
      spaceBetween: 30,
    },
    1199: {
      slidesPerView: 6,
      spaceBetween: 30,
    },
    1350: {
      slidesPerView: 6,
      spaceBetween: 30,
    },
  },
};

const CategoryProfessionSlider = ({ profession, currentPageAide }) => {
  return (
    <Swiper {...swiperOptions} className="relative">
      {profession.length > 0 &&
        profession.map((item, i) => (
          <React.Fragment key={i}>
            <SwiperSlide  key={i}>
              <CategoryGrid item={item} currentPageAide={currentPageAide} />
            </SwiperSlide>
          </React.Fragment>
        ))}
    </Swiper>
  );
};

export default CategoryProfessionSlider;
